var _mask, _path, _circle, _mask2, _path2, _path3, _path4, _path5, _rect, _circle2, _rect2, _rect3, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssignedHours(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_6139_10191",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1516 7.74081C12.3217 7.87576 12.5708 7.84808 12.6897 7.66632C12.9751 7.22981 13.1796 6.74413 13.292 6.23258C13.4325 5.5927 13.4253 4.92919 13.2709 4.29253C13.1164 3.65586 12.8188 3.0628 12.4007 2.55846C11.9825 2.05413 11.4549 1.65179 10.8578 1.38207C10.2608 1.11235 9.6101 0.982335 8.95526 1.00193C8.30042 1.02152 7.65867 1.1902 7.07883 1.49513C6.49899 1.80006 5.99632 2.23322 5.60908 2.76165C5.29949 3.18411 5.07019 3.65857 4.93134 4.16133C4.87352 4.37067 5.01736 4.57585 5.23111 4.61434C5.44486 4.65283 5.6472 4.50983 5.70927 4.3017C5.82421 3.91631 6.00461 3.5525 6.24347 3.22655C6.56002 2.79459 6.97092 2.4405 7.4449 2.19124C7.91889 1.94197 8.44348 1.80409 8.97878 1.78807C9.51407 1.77206 10.046 1.87833 10.534 2.09882C11.0221 2.3193 11.4534 2.64819 11.7952 3.06045C12.137 3.47272 12.3803 3.95751 12.5065 4.47795C12.6328 4.99839 12.6387 5.54077 12.5238 6.06383C12.4371 6.45852 12.2833 6.83436 12.0701 7.17535C11.955 7.3595 11.9814 7.60586 12.1516 7.74081Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1516 7.74081C12.3217 7.87576 12.5708 7.84808 12.6897 7.66632C12.9751 7.22981 13.1796 6.74413 13.292 6.23258C13.4325 5.5927 13.4253 4.92919 13.2709 4.29253C13.1164 3.65586 12.8188 3.0628 12.4007 2.55846C11.9825 2.05413 11.4549 1.65179 10.8578 1.38207C10.2608 1.11235 9.6101 0.982335 8.95526 1.00193C8.30042 1.02152 7.65867 1.1902 7.07883 1.49513C6.49899 1.80006 5.99632 2.23322 5.60908 2.76165C5.29949 3.18411 5.07019 3.65857 4.93134 4.16133C4.87352 4.37067 5.01736 4.57585 5.23111 4.61434C5.44486 4.65283 5.6472 4.50983 5.70927 4.3017C5.82421 3.91631 6.00461 3.5525 6.24347 3.22655C6.56002 2.79459 6.97092 2.4405 7.4449 2.19124C7.91889 1.94197 8.44348 1.80409 8.97878 1.78807C9.51407 1.77206 10.046 1.87833 10.534 2.09882C11.0221 2.3193 11.4534 2.64819 11.7952 3.06045C12.137 3.47272 12.3803 3.95751 12.5065 4.47795C12.6328 4.99839 12.6387 5.54077 12.5238 6.06383C12.4371 6.45852 12.2833 6.83436 12.0701 7.17535C11.955 7.3595 11.9814 7.60586 12.1516 7.74081Z",
    fill: "white",
    stroke: "#1A76D2",
    strokeWidth: 2,
    mask: "url(#path-1-inside-1_6139_10191)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.02986,
    cy: 5.9704,
    r: 0.897048,
    stroke: "#1A76D2",
    strokeWidth: 0.5
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2_6139_10191",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.95801 2.84709C8.95801 2.69012 9.08525 2.56288 9.24221 2.56288C9.39918 2.56288 9.52642 2.69012 9.52642 2.84709V4.90758H8.95801V2.84709Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.95801 2.84709C8.95801 2.69012 9.08525 2.56288 9.24221 2.56288C9.39918 2.56288 9.52642 2.69012 9.52642 2.84709V4.90758H8.95801V2.84709Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.52642 4.90758V6.10758H10.7264V4.90758H9.52642ZM8.95801 4.90758H7.75801V6.10758H8.95801V4.90758ZM8.32642 2.84709V4.90758H10.7264V2.84709H8.32642ZM9.52642 3.70758H8.95801V6.10758H9.52642V3.70758ZM10.158 4.90758V2.84709H7.75801V4.90758H10.158ZM9.24221 3.76288C8.73643 3.76288 8.32642 3.35287 8.32642 2.84709H10.7264C10.7264 2.02738 10.0619 1.36288 9.24221 1.36288V3.76288ZM9.24221 1.36288C8.42251 1.36288 7.75801 2.02738 7.75801 2.84709H10.158C10.158 3.35287 9.74799 3.76288 9.24221 3.76288V1.36288Z",
    fill: "#1A76D2",
    mask: "url(#path-3-inside-2_6139_10191)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2676 5.26281L11.2676 5.54702L11.2676 5.26281Z",
    fill: "white",
    stroke: "#1A76D2",
    strokeWidth: 0.284206
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.83755 11.1983C7.95776 10.4792 8.57763 9.95069 9.30669 9.94567L12.0009 9.92713C12.9095 9.92087 13.6149 10.7174 13.4989 11.6186L13.4252 12.1911C13.3289 12.9393 12.6919 13.4996 11.9375 13.4996H9.22441C8.2972 13.4996 7.59206 12.6668 7.74494 11.7522L7.83755 11.1983Z",
    stroke: "#1A76D2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.13112,
    y: 13.4261,
    width: 7.00701,
    height: 0.382349,
    rx: 0.191175,
    fill: "white",
    stroke: "#1A76D2",
    strokeWidth: 0.382349
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.17889,
    cy: 7.31276,
    r: 1.8034,
    stroke: "#1A76D2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.51491,
    y: 11.8764,
    width: 0.426309,
    height: 1.02398,
    rx: 0.213155,
    fill: "#1A76D2",
    stroke: "#1A76D2",
    strokeWidth: 0.426309
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5.39431,
    y: 11.706,
    width: 0.426309,
    height: 0.426803,
    rx: 0.213155,
    fill: "#1A76D2",
    stroke: "#1A76D2",
    strokeWidth: 0.426309
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.77143 9.91473C2.45862 9.94317 1.73063 10.2219 1.32114 11.1091C0.911644 11.9963 0.979893 12.73 1.0652 12.9859",
    stroke: "#1A76D2",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.74334 9.91473C6.00386 10.0427 6.33881 10.2986 6.5249 10.5546",
    stroke: "#1A76D2",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignedHours);
export default __webpack_public_path__ + "static/media/assignedHours.6d1318d4f05a5abfee6f907ca5d72f22.svg";
export { ForwardRef as ReactComponent };